import { faCheck, faStepBackward } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FormProvider, useForm } from "react-hook-form";
import { useRegistrarAcordoContext } from "..";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import SpinnerUAU from "../../../../../Components/Loding/SpinnerUAU";
import Table from "../../../../../Components/Table";
import { useUserInfor } from "../../../../../Context/User";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IParcelaGeradaNovoFluxo } from "../../../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { comparaDatasDia } from "../../../../../Validations/DateValidation";

import ParcelaNovoFluxo from "./ParcelaNovoFluxo";

interface IDateVenFormData {
    parcelas: {
        [index: string]: {
            dataVencimento: string;
        };
    };
}

const amortText = ["0 - Gradiente", "1 - Price", "2 - SAC", "3 - Simples"];

export default function NovoFluxo() {
    const { Config } = useUserInfor();

    const { novoFluxo, goToStep, finalizarAcordo } =
        useRegistrarAcordoContext();
    const [lstParcelasNovoFluxo, setLstParcelasNovoFluxo] =
        useState<Array<IParcelaGeradaNovoFluxo>>();
    const [loading, setLoading] = useState(false);

    const dateVenForm = useForm<IDateVenFormData>();

    useEffect(() => {
        setLoading(true);
        novoFluxo
            .get()
            .then(setLstParcelasNovoFluxo)
            .finally(() => setLoading(false));
    }, [novoFluxo]);

    const handleRegistrarAcordoConfirmForm = useAsyncCallback(
        async (formData: IDateVenFormData) => {
            if (
                Config.ConfigCobrancaDTO
                    .FL_ACORDO_ALTERAR_DATA_VENCIMENTO_FUTURA
            ) {
                lstParcelasNovoFluxo?.forEach((p) => {
                    const dataVen =
                        formData.parcelas[`${p.Tipo_pg}${p.NumParc_pg}${p.GrupoParc_pg}`]
                            ?.dataVencimento;
                    if (dataVen) p.Data_pg = dataVen;
                });
            }
            return finalizarAcordo();
        }
    );

    //Table
    const columns: Array<ColumnDescription> = [
        {
            dataField: "NumParcGer_pg",
            text: "Configuração de Parcelas",
            formatter: (_c, row) => (
                <ParcelaNovoFluxo
                    parcela={row}
                    FL_ACORDO_ALTERAR_DATA_VENCIMENTO_FUTURA={
                        Config.ConfigCobrancaDTO
                            .FL_ACORDO_ALTERAR_DATA_VENCIMENTO_FUTURA
                    }
                />
            ),
            headerClasses: "d-none",
        },
    ];
    const columnsTableView: Array<ColumnDescription<IParcelaGeradaNovoFluxo>> =
        [
            {
                dataField: "Tipo_pg",
                text: "Tipo",
                classes: "p-3 ws-nowrap",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "NumParc_pg",
                text: "Parcela",
                classes: "p-3 ws-nowrap",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "IdxReaj_pg",
                text: "Correção",
                classes: "p-3 ws-nowrap",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "AmortParc_pg",
                text: "Amortização",
                formatter: (cell) => amortText[cell],
                classes: "p-3 ws-nowrap",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "Valor_pg",
                text: "Valor Principal",
                formatter: formatMoneyReais,
                classes: "p-3 ws-nowrap",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "ValReaj_pg",
                text: "Valor Reajustado",
                formatter: formatMoneyReais,
                classes: "p-3 ws-nowrap",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "Data_pg",
                text: "Data de Vencimento",
                formatExtraData: dateVenForm.formState.errors,
                formatter: (cell, row, _, errors) => (
                    <input
                        name={`parcelas.${row.Tipo_pg}${row.NumParc_pg}${row.GrupoParc_pg}.dataVencimento`}
                        ref={dateVenForm.register({
                            validate: (date) =>
                                comparaDatasDia(
                                    new Date(`${date}T23:59Z`),
                                    new Date()
                                )
                                    ? true
                                    : "Data Retroativa!",
                        })}
                        className={`form-control ${errors.parcelas?.[`${row.Tipo_pg}${row.NumParc_pg}${row.GrupoParc_pg}`]
                                ?.dataVencimento
                                ? " is-invalid"
                                : ""
                            }`}
                        defaultValue={moment(cell).format("YYYY-MM-DD")}
                        disabled={
                            !Config.ConfigCobrancaDTO
                                .FL_ACORDO_ALTERAR_DATA_VENCIMENTO_FUTURA
                        }
                        type="date"
                    />
                ),
                classes: "p-3 ws-nowrap",
                align: "center",
                headerAlign: "center",
            },
        ];

    return (
        <div>
            {loading ? (
                <SpinnerUAU />
            ) : lstParcelasNovoFluxo ? (
                <FormProvider {...dateVenForm}>
                    <form
                        id="form-parcelas-novo-fluxo"
                        onSubmit={dateVenForm.handleSubmit(
                            handleRegistrarAcordoConfirmForm.execute
                        )}
                    >
                        <Table
                            data={lstParcelasNovoFluxo}
                            columns={columns}
                            keyField="NumParcGer_pg"
                            bordered={false}
                            rowClasses="border-bottom border-gray checkbox-table"
                            sizePerPage={lstParcelasNovoFluxo.length}
                            tableView={{
                                columns: columnsTableView,
                                // dando unregister para não ter problemas na troca de contexto tablecard
                                onViewChange: () => {
                                    lstParcelasNovoFluxo.forEach((p) => {
                                        dateVenForm.unregister([
                                            `parcelas.${p.Tipo_pg}${p.NumParc_pg}${p.GrupoParc_pg}.dataVencimento`,
                                        ]);
                                    });
                                },
                            }}
                            wrapperClasses="y-scroll maxHeight-300 mb-2"
                            noPagination
                            noSearch
                        />
                    </form>
                </FormProvider>
            ) : (
                <span className="text-center text muted">
                    Não foi possível simular o novo novo fluxo
                </span>
            )}

            <div className="d-flex justify-content-between mt-5">
                <button
                    className="btn btn-primary"
                    onClick={() => goToStep("selecModelo")}
                    disabled={handleRegistrarAcordoConfirmForm.loading}
                >
                    <FontAwesomeIcon className="mr-2" icon={faStepBackward} />
                    Voltar
                </button>
                <button
                    disabled={
                        !lstParcelasNovoFluxo ||
                        handleRegistrarAcordoConfirmForm.loading
                    }
                    className="btn btn-primary d-flex align-items-center g-2"
                    type="submit"
                    form="form-parcelas-novo-fluxo"
                >
                    Confirmar Acordo
                    {handleRegistrarAcordoConfirmForm.loading ? (
                        <Spinner size="sm" />
                    ) : (
                        <FontAwesomeIcon icon={faCheck} />
                    )}
                </button>
            </div>
        </div>
    );
}
